import ClassicQuizBasicModel from "./ClassicQuizBasicModel";
import ClassicQuizParticipationQuestionModel from "./ClassicQuizParticipationQuestionModel";

export default class ClassicQuizUserParticipationModel {
  public classicQuizId: string = null;
  public classicQuizModel: ClassicQuizBasicModel = null;
  public correct: number = null;
  public classicQuizQuestions: number = null;
  public personalBest: number = null;
  public points: number = null;
  public answers: ClassicQuizParticipationQuestionModel[] = [];
  public attempts: number = 0;
}
